import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map,switchMap, withLatestFrom } from "rxjs/operators";

import { MpAdminService } from "../../../services/api/mp-admin.service";
import { MpAdminActions } from "../../actions/mp-admin.actions";
import { FailState } from "../../models/fail-state";
import { AdminVendorStatsState } from "../../models/mp-admin/vendor-stats-state";
import { AppState } from "../../reducers";
import { MpAdminSelectors } from "../../selectors/mp-admin.selectors";

@Injectable()
export class ExcessProposalFundsEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.excessFunds.get),
			withLatestFrom(this.store.select(MpAdminSelectors.excessFunds)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(action, state)
					? of(MpAdminActions.excessFunds.getSuccess(state))
					: of(MpAdminActions.excessFunds.getApi())
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpAdminActions.excessFunds.getApi),
			switchMap(() =>
				this.adminService.excessProposalFunds().pipe(
					map((funds) =>
						MpAdminActions.excessFunds.getSuccess({ funds, loading: false })
					),
					catchError((error) =>
						of(MpAdminActions.excessFunds.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private store: Store<AppState>,
		private actions: Actions,
		private adminService: MpAdminService
	) {}

	private canUseStoreValue(action, state: AdminVendorStatsState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
